import { render, staticRenderFns } from "./RequisitionIcon.vue?vue&type=template&id=c18d3eb6&scoped=true&"
import script from "./RequisitionIcon.vue?vue&type=script&lang=ts&"
export * from "./RequisitionIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionIcon.vue?vue&type=style&index=0&id=c18d3eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d3eb6",
  null
  
)

export default component.exports